import { render, staticRenderFns } from "./Allbuy.vue?vue&type=template&id=85538678&"
import script from "./Allbuy.vue?vue&type=script&lang=js&"
export * from "./Allbuy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports